import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-6xl font-bold text-red-500">404</h1>
        <p className="mt-4 text-xl text-gray-700">
          Oops! Halaman yang Anda cari tidak ditemukan.
        </p>
        <p className="mt-2 text-gray-500">
          Sepertinya Anda telah mencapai jalan buntu. Mari kita kembalikan Anda
          ke jalur yang benar!
        </p>
        <div className="mt-6">
          <button
            onClick={() => navigate(-1)} // kembali ke page terakhir sebelumnya
            className="inline-block px-6 py-3 text-lg font-semibold text-white bg-blue-500 hover:bg-blue-600 rounded-lg shadow-md transition duration-300"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
